<ng-template flLoading [flLoadingUntil]="form" flLoadingStrategy="overlay" flLoadingColor="primary">
  <div [formGroup]="form">
    <div gdArea="dutyStart" fxLayout="column">
      <label>Duty on time</label>
      <fl-date-time-input inputType="dateTime" [inputControl]="form?.get('dutyPeriodStartTime')">
      </fl-date-time-input>
    </div>
    <div gdArea="dutyEnd" fxLayout="column">
      <label>Duty off time</label>
      <fl-date-time-input inputType="dateTime" [inputControl]="form?.get('dutyPeriodEndTime')">
      </fl-date-time-input>
    </div>
    <fl-base-autocomplete-v2
      gdArea="base"
      hint="Required"
      [disableGoldenHourBases]="true"
      formControlName="baseId"
    ></fl-base-autocomplete-v2>
    <fl-aircraft-autocomplete-v2
      gdArea="aircraft"
      hint="Required"
      formControlName="aircraftId"
    ></fl-aircraft-autocomplete-v2>
    <div gdArea="comments" fxLayout="column" fxLayoutGap="20px">
      <mat-form-field fxFlex fxFill *ngIf="dutyTimeExceeds14Hours$ | async">
        <textarea
          matInput
          matTextareaAutosize
          formControlName="justification"
          placeholder="Excess Duty Time Justification"
        ></textarea>
        <mat-error *ngIf="form.controls.justification.errors as errors">{{
          errors.justificationRequiredForDutyTimesExceeding14Hours.message
        }}</mat-error>
      </mat-form-field>
      <mat-form-field fxFlex fxFill *ngIf="restTimeLessThan10Hours$ | async">
        <textarea
          matInput
          matTextareaAutosize
          formControlName="restJustification"
          placeholder="10 Hour Rest Time Justification"
        ></textarea>
        <mat-error *ngIf="form.controls.restJustification.errors as errors">{{
          errors.justificationRequiredForRestTimeLessThan10Hours.message
        }}</mat-error>
      </mat-form-field>
      <mat-form-field fxFill>
        <textarea
          matInput
          matTextareaAutosize
          formControlName="comments"
          placeholder="Comments"
        ></textarea>
      </mat-form-field>
    </div>
    <fl-message-box gdArea="errors" level="error" [messages]="errors$ | async"></fl-message-box>
  </div>
</ng-template>
